import React from "react";
import HiddenComponent from '../common3/HiddenComponent'

const LogoutEdit = (props) => {
  const { extra = {},builder } = props;
  const { options = null,optionsType } = extra;

  return <HiddenComponent />


};

export default LogoutEdit
